import {Collection} from "../../collections/base";
import {BBModel} from "../../bb_model";
import {ClientCollections} from "../../collections/client_collections";
import {ClientModel} from "../core/client";

class AdminClientModel extends ClientModel {

    constructor(data) {
        super(data);
    }

    static $query(params) {
        //  if (params.per_page) {
        // For paginated content.
        //    return super.$query({ modelName: 'client', modelNameForResource: 'clients' }, params);
        //  } else {
        const {company} = params;
        return new Promise((resolve, reject) => {

            if (company.$has('client')) {

                params.company_id = company.id;

                if (params.flush)
                    company.$flush('client', params);


                company.$get('client', params).then((resource) => {
                        if (resource.$has('clients')) {
                            return resource.$get('clients').then((clients) => {
                                    const models = (Array.from(clients).map(c => new BBModel.Admin.Client(c)));

                                    clients = new Collection.Client(resource, models, params);
                                    clients.total_entries = resource.total_entries;
                                    ClientCollections.add(clients);
                                    return resolve(clients);
                                }
                                , err => reject(err));
                        } else {
                            const client = new BBModel.Admin.Client(resource);
                            return resolve(client);
                        }
                    }
                    , err => reject(err));
            } else {
                console.warn('company has no client link');
                reject('company has no client link');
            }
        });
        //   }
    }

    $delete() {
        this.$flush('self');
        return this.$del('self');
    }


    /**
     * @param {object} data The client data
     * @description
     * Update the data in according of the data parameter
     *
     * @returns {array} Returns a promise
     */
    $update(data) {
        if (!data) {
            data = this.getPostData();
        }

        return this.$put('self', {}, data).then((res) => {
//                ClientCollections.updateAll(res.$link('self').href);
            this.constructor(res);
        });
    }

}

export {
    AdminClientModel
}